module.exports = __webpack_public_path__ + "img/7.2da88b05.jpg";